import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppConfig from '../../app_config/appConfig';

const PrivateRoute = () => {
  const authStore = useSelector(state => state.authenticationData);
  const location = useLocation();
 
  return authStore.isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to={AppConfig.routePaths.login} state={{ from: location }} replace />
  );
};


export default PrivateRoute;
